(function() {
  var SockJS,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

  SockJS = require('public/bower_components/sockjs-client/dist/sockjs');

  exports.Socket = (function() {
    Socket.prototype.messageHandlers = {
      reload: [
        function(data) {
          return $('#reload-site').show();
        }
      ],
      conversionComplete: [
        function(data) {
          if ($('#conv-confirm').is(':visible')) {
            $('#conv-confirm').toggle('slide');
          }
          return $('#conv-complete').toggle('slide');
        }
      ],
      conversionConfirm: [
        function(data) {
          if ($('#conv-complete').is(':visible')) {
            $('#conv-complete').toggle('slide');
          }
          return $('#conv-confirm').toggle('slide');
        }
      ],
      confirmationStatusUpdate: [
        function(data) {
          return typeof window.confirmationStatusUpdate === "function" ? window.confirmationStatusUpdate(data) : void 0;
        }
      ],
      conversionRequestSent: [
        function(data) {
          return typeof window.conversionRequestSent === "function" ? window.conversionRequestSent(data) : void 0;
        }
      ],
      inputFileUploading: [
        function(data) {
          return typeof window.inputFileUploading === "function" ? window.inputFileUploading(data) : void 0;
        }
      ],
      inputFileProcessed: [
        function(data) {
          return typeof window.inputFileProcessed === "function" ? window.inputFileProcessed(data) : void 0;
        }
      ],
      vpsCount: [
        function(data) {
          return typeof window.confirmation === "function" ? window.confirmation(data) : void 0;
        }
      ],
      vpsStatusUpdate: [
        function(data) {
          return typeof window.socketUpdateVps === "function" ? window.socketUpdateVps(data) : void 0;
        }
      ],
      dataPackagePending: [
        function(data) {
          if (!$('#download-pending').is(':visible')) {
            $('#download-pending').toggle('slide');
          }
          return typeof window.downloadPreparing === "function" ? window.downloadPreparing(true) : void 0;
        }
      ],
      dataPackageReady: [
        function(data) {
          if ($('#download-pending').is(':visible')) {
            $('#download-pending').toggle('slide');
          }
          if (!$('#download-complete').is(':visible')) {
            $('#download-complete').toggle('slide');
          }
          return typeof window.downloadPreparing === "function" ? window.downloadPreparing(false) : void 0;
        }
      ],
      fieldViewImportingSyncData: [
        function(data) {
          if ($('#fieldview-pending').is(':visible')) {
            $('#fieldview-pending').toggle('slide');
          }
          if (!$('#fieldview-importing').is(':visible')) {
            return $('#fieldview-importing').toggle('slide');
          }
        }
      ],
      fieldViewNewSyncData: [
        function(data) {
          if ($('#fieldview-importing').is(':visible')) {
            $('#fieldview-importing').toggle('slide');
          }
          if (!$('#fieldview-pending').is(':visible')) {
            return $('#fieldview-pending').toggle('slide');
          }
        }
      ],
      johnDeereImportingSyncData: [
        function(data) {
          if ($('#johndeere-pending').is(':visible')) {
            $('#johndeere-pending').toggle('slide');
          }
          if (!$('#johndeere-importing').is(':visible')) {
            return $('#johndeere-importing').toggle('slide');
          }
        }
      ],
      johnDeereImportingSyncDataYield: [
        function(data) {
          if ($('#johndeere-pending-yield').is(':visible')) {
            $('#johndeere-pending-yield').toggle('slide');
          }
          if (!$('#johndeere-importing-yield').is(':visible')) {
            return $('#johndeere-importing-yield').toggle('slide');
          }
        }
      ],
      johnDeereImportingSyncDataApplication: [
        function(data) {
          if ($('#johndeere-pending-application').is(':visible')) {
            $('#johndeere-pending-application').toggle('slide');
          }
          if (!$('#johndeere-importing-application').is(':visible')) {
            return $('#johndeere-importing-application').toggle('slide');
          }
        }
      ],
      johnDeereImportingSyncDataPlanting: [
        function(data) {
          if ($('#johndeere-pending-planting').is(':visible')) {
            $('#johndeere-pending-planting').toggle('slide');
          }
          if (!$('#johndeere-importing-planting').is(':visible')) {
            return $('#johndeere-importing-planting').toggle('slide');
          }
        }
      ],
      fieldViewImportingSyncDataYield: [
        function(data) {
          if ($('#fieldview-pending-yield').is(':visible')) {
            $('#fieldview-pending-yield').toggle('slide');
          }
          if (!$('#fieldview-importing-yield').is(':visible')) {
            return $('#fieldview-importing-yield').toggle('slide');
          }
        }
      ],
      fieldViewImportingSyncDataApplication: [
        function(data) {
          if ($('#fieldview-pending-application').is(':visible')) {
            $('#fieldview-pending-application').toggle('slide');
          }
          if (!$('#fieldview-importing-application').is(':visible')) {
            return $('#fieldview-importing-application').toggle('slide');
          }
        }
      ],
      fieldViewImportingSyncDataPlanting: [
        function(data) {
          if ($('#fieldview-pending-planting').is(':visible')) {
            $('#fieldview-pending-planting').toggle('slide');
          }
          if (!$('#fieldview-importing-planting').is(':visible')) {
            return $('#fieldview-importing-planting').toggle('slide');
          }
        }
      ],
      fieldViewNewSyncDataYield: [
        function(data) {
          if ($('#fieldview-importing-yield').is(':visible')) {
            $('#fieldview-importing-yield').toggle('slide');
          }
          if (!$('#fieldview-pending-yield').is(':visible')) {
            return $('#fieldview-pending-yield').toggle('slide');
          }
        }
      ],
      fieldViewNewSyncDataApplication: [
        function(data) {
          if ($('#fieldview-importing-application').is(':visible')) {
            $('#fieldview-importing-application').toggle('slide');
          }
          if (!$('#fieldview-pending-application').is(':visible')) {
            return $('#fieldview-pending-application').toggle('slide');
          }
        }
      ],
      fieldViewNewSyncDataPlanting: [
        function(data) {
          if ($('#fieldview-importing-planting').is(':visible')) {
            $('#fieldview-importing-planting').toggle('slide');
          }
          if (!$('#fieldview-pending-planting').is(':visible')) {
            return $('#fieldview-pending-planting').toggle('slide');
          }
        }
      ],
      johnDeereNewSyncData: [
        function(data) {
          if ($('#johndeere-importing').is(':visible')) {
            $('#johndeere-importing').toggle('slide');
          }
          if (!$('#johndeere-pending').is(':visible')) {
            return $('#johndeere-pending').toggle('slide');
          }
        }
      ],
      johnDeereNewSyncDataYield: [
        function(data) {
          if ($('#johndeere-importing-yield').is(':visible')) {
            $('#johndeere-importing-yield').toggle('slide');
          }
          if (!$('#johndeere-pending-yield').is(':visible')) {
            return $('#johndeere-pending-yield').toggle('slide');
          }
        }
      ],
      johnDeereNewSyncDataApplication: [
        function(data) {
          if ($('#johndeere-importing-application').is(':visible')) {
            $('#johndeere-importing-application').toggle('slide');
          }
          if (!$('#johndeere-pending-application').is(':visible')) {
            return $('#johndeere-pending-application').toggle('slide');
          }
        }
      ],
      johnDeereNewSyncDataPlanting: [
        function(data) {
          if ($('#johndeere-importing-planting').is(':visible')) {
            $('#johndeere-importing-planting').toggle('slide');
          }
          if (!$('#johndeere-pending-planting').is(':visible')) {
            return $('#johndeere-pending-planting').toggle('slide');
          }
        }
      ],
      updateConfirmationCount: [
        function(data) {
          return typeof window.confirmation === "function" ? window.confirmation(data) : void 0;
        }
      ],
      down: [
        function(data) {
          var ref;
          $('.down-dialog').modal('show');
          return (ref = window.header) != null ? ref.disable() : void 0;
        }
      ],
      up: [
        function(data) {
          var ref;
          $('.down-dialog').modal('hide');
          return (ref = window.header) != null ? ref.enable() : void 0;
        }
      ]
    };

    function Socket() {
      this.register = bind(this.register, this);
      this.reconnect = bind(this.reconnect, this);
      this.open = bind(this.open, this);
      this.whenopen = bind(this.whenopen, this);
      this.onOpen = [];
      this.open();
      setInterval((function(_this) {
        return function() {
          if (!_this.socket) {
            return _this.open();
          }
        };
      })(this), 5000);
    }

    Socket.prototype.whenopen = function(callback) {
      var ref;
      if (((ref = this.socket) != null ? ref.readyState : void 0) === 1) {
        return callback();
      } else {
        return this.onOpen.push(callback);
      }
    };

    Socket.prototype.open = function() {
      var hostname;
      hostname = window.location.host;
      this.socket = new SockJS(window.location.protocol + "//" + hostname + "/ws");
      this.socket.onopen = (function(_this) {
        return function() {
          var callback, j, len, ref;
          ref = _this.onOpen;
          for (j = 0, len = ref.length; j < len; j++) {
            callback = ref[j];
            callback();
          }
          return _this.onOpen = [];
        };
      })(this);
      this.socket.onmessage = (function(_this) {
        return function(e) {
          var func, i, json, ref, results;
          json = $.parseJSON(e.data);
          ref = _this.messageHandlers[json.channel];
          results = [];
          for (i in ref) {
            func = ref[i];
            debugLog('Calling socket handler', json.channel, json.data, i, func);
            results.push(func(json.data));
          }
          return results;
        };
      })(this);
      return this.socket.onclose = (function(_this) {
        return function() {
          return _this.socket = null;
        };
      })(this);
    };

    Socket.prototype.reconnect = function() {
      var ref, ref1;
      if (((ref = this.socket) != null ? ref.readyState : void 0) === SockJS.CONNECTING) {
        return this.socket.onopen = (function(_this) {
          return function() {
            var ref1;
            return (ref1 = _this.socket) != null ? ref1.close() : void 0;
          };
        })(this);
      } else {
        return (ref1 = this.socket) != null ? ref1.close() : void 0;
      }
    };

    Socket.prototype.register = function(channel, handler) {
      var idx;
      if (!this.messageHandlers[channel]) {
        this.messageHandlers[channel] = [];
      }
      idx = this.messageHandlers[channel].push(handler) - 1;
      debugLog('registering', channel, idx);
      return (function(_this) {
        return function() {
          debugLog('unregistering', channel, idx);
          delete _this.messageHandlers[channel][idx];
        };
      })(this);
    };

    return Socket;

  })();

}).call(this);
